import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.0677 7.07007L12 0.0690918L4.93229 7.07007C1.02257 10.9429 1.02257 17.2259 4.93229 21.0987C8.83675 24.9663 15.1632 24.9663 19.0677 21.0987C22.9774 17.2259 22.9774 10.9429 19.0677 7.07007ZM18 13.9963C18 17.31 15.3137 19.9963 12 19.9963V7.99634C15.3137 7.99634 18 10.6826 18 13.9963Z"}}]};

const SaturationFilled = Vue.extend<IconProps>({
  name: 'SaturationFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'saturation-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default SaturationFilled;
